module.exports = __webpack_public_path__ + "static/image-02-c@2x-eb15f7d387c35118e90bc2422470e46c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/case-studies/cabify/image-02-c@2x.jpg
// module id = 339
// module chunks = 3627797113349 20562973939449 33019919093843